import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_line2",
  "use": "icon-home_line2-usage",
  "viewBox": "0 0 31 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 4\" id=\"icon-home_line2\"><defs><style>#icon-home_line2 .a{fill:none;stroke:#fc6e09;stroke-linecap:round;stroke-width:4px;}</style></defs><line class=\"a\" x2=\"27\" transform=\"translate(2 2)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol